export default {
  release: '16.3',
  date: 'August 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-3-released/#this-months-notable-contributor-thomas-spear',
  contributors: [
    {
      name: 'Thomas Spear',
      gitlabUsername: 'tspearconquest',
    },
  ],
  writeUp: `Thomas has contributed [15 merge requests](https://gitlab.com/gitlab-org/charts/gitlab-agent/-/merge_requests?scope=all&state=merged&author_username=tspearconquest)
to the [GitLab agent for Kubernetes Helm chart](https://gitlab.com/gitlab-org/charts/gitlab-agent)
in the last month!

Thomas made the chart more mature in terms of security and observability,
made it simpler to troubleshoot issues with agentk, and improved the CI/CD pipeline to check for breaking changes.

As a security engineer, Thomas enjoys collaborating with the team to provide
a more secure default deployment of the Gitlab agent.
Thomas expressed thanks for all the timely reviews and feedback, which team members were
more than happy to provide.

Thank you Thomas, your contributions are hugely appreciated! 🙌

We would also like to take the opportunity to thank [Shane Maglangit](https://gitlab.com/ShaneMaglangit)
and [Batuhan Apaydın](https://gitlab.com/batuhan.apaydin) for their great contributions.`,
};
